export const TELEGRAM_VIP_URL = process.env.REACT_APP_TELEGRAM_VIP_URL || "https://t.me/m/9SduQIZSZDA1";
